"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReactElement = void 0;
var _react = require("react");
const isReactElement = (obj, name) => {
  if (! /*#__PURE__*/(0, _react.isValidElement)(obj)) return false;
  const type = obj.type;
  return typeof obj !== 'boolean' && typeof obj !== 'string' && typeof obj !== 'number' && typeof obj === 'object' && type.displayName === name;
};
exports.isReactElement = isReactElement;